<template>
    <div class="ednDetail">
        <template v-if="aucaActiveIndex != 'null' && talentCategory.length > 0 && talentCategory[aucaActiveIndex]">
            <MainMenu 
            :banner="talentCategory[aucaActiveIndex].banner" 
            :mobileBanner="talentCategory[aucaActiveIndex].web_banner" 
            :menu="talentCategory"/>
        </template>
        <div class="container">
            <router-view/>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import MainMenu from '../../components/mainMenu.vue';
export default {
    name: "ednDetail",
    data() {
        return {
        };
    },
    computed: {
        ...mapState(['navData', 'talentCategory', 'aucaActiveIndex'])
    },
    components: {
        MainMenu
        
    },
    mounted() {
        this.$store.dispatch('getTalentCategory')
    },
    destroyed() {},
    watch: {
        $route: 'choosePath',
        talentCategory: {
            handler: 'choosePath',
            immediate: true
        },
    },
    methods: {
        choosePath(){
            if(this.talentCategory.length > 0){
                for (let i = 0; i < this.talentCategory.length; i++) {
                    const item = this.talentCategory[i];
                    if(item.link == this.$route.path){
                        this.$store.state.aucaActiveIndex = i;
                        break;
                    }
                }
            }
        }
    },
};
</script>

<style scoped lang="scss">
.ednDetail{
    /deep/{
        .main_menu{
            .menu{
                .menu_inner{
                    .item{
                        font-size: .24rem;
                    }
                }
            }
        }
    }
}
.container{
    padding: .6rem 0;
    @media only screen and (max-width: 1200px) {
        padding: 1rem 0;
    }
}
</style>